// The market's pages: a hash route picks the page; each page loads what it shows from the market's addresses.

import { SESSION_ENDED } from './api.ts';
import { markSessionEnded, renderAdmin, renderLogin } from './admin.ts';
import { renderDetail, renderList } from './public.ts';
import { REFRESH, listenForActions, must, stopPoll, closeModal } from './util.ts';
import './admin-items.ts';
import './admin-shared.ts';

async function render(): Promise<void> {
  stopPoll();
  // Each visit gets a page of its own, so a page still loading when the person moves on writes to one nobody sees.
  const holder = document.createElement('div');
  must('#app').replaceChildren(holder);
  const parts = location.hash.replace(/^#\/?/, '').split('/').filter(Boolean).map(decodeURIComponent);
  const [first = 'market', second] = parts;
  if (first === 'admin') {
    await renderAdmin(holder, parts);
  } else if (first === 'market') {
    renderList(holder);
  } else if (first === 'items' && second) {
    renderDetail(holder, second);
  } else if ((first === 'skills' || first === 'plugins') && second) {
    location.replace(`#/items/${encodeURIComponent(second)}`);
  } else {
    location.replace('#/market');
  }
}

listenForActions();
window.addEventListener('hashchange', () => {
  closeModal();
  void render();
  window.scrollTo(0, 0);
});
window.addEventListener(REFRESH, () => void render());
// A session that ended while the administrator was working: back to logging in, then to where they were.
window.addEventListener(SESSION_ENDED, () => {
  stopPoll();
  if (location.hash.startsWith('#/admin')) {
    const holder = document.createElement('div');
    must('#app').replaceChildren(holder);
    markSessionEnded();
    renderLogin(holder);
  }
});
void render();
